import React from "react";
import { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import Header from "./components/Header";
import Socials from "./components/Socials";
import DownloadButton, { DownloadButtonDP } from "./components/DownloadButton";
import Figure from "react-bootstrap/Figure";
import Skills from "./components/Skills";
import MyProjects from "./components/MyProjects";
import Footer from "./components/Footer";
import { Grid } from "@mui/material";
import ProjectDetails from "./components/ProjectDetails";
import "./index.css";
import LandingPage from "./components/LandingPage";
import { Lan } from "@mui/icons-material";
import styled from "styled-components";
import { Container } from "react-bootstrap";
//import "./custom.scss";

// function App() {
//   const [openModal, setOpenModal] = useState({ state: false, project: null });
//   return (
//     // <Router>
//     <div>
//       {/* Header */}
//       <Header />
//       {/* Landing page */}

//       {/* <div id="home" className="landing-page"> */}
//       {/* <Icon />  */}
//       {/* <Figure.Image
//           width={1920}
//           height={1080}
//           alt="1920x1080"
//           src="assets/landing-page.png"
//         />
//         <div className="rel" style={{ width: "100%" }}>
//           <Socials />
//         </div>
//       </div> */}
//       <div>
//         <h1> Hello, I am Devika</h1>
//         <p className="subheading">
//           A passionate designer and developer who loves to create user-friendly
//           and functional solutions.
//         </p>
//       </div>

//       {/* About me section */}
//       <div style={{ padding: "3%" }}>
//         <h1 className="heading" id="Me">
//           About Me
//         </h1>
//         {/* image + bio */}
//         <Grid container>
//           <div className="mediaquery">
//             {/* <Grid item xs={6} alignItems="center"> */}
//             <Figure.Image
//               src="assets/download-me-torso.png"
//               alt="profile"
//             ></Figure.Image>

//             <p className="subheading about-me">
//               Currently pursuing BE in Computer Science, my passion for art and
//               creation led me to explore graphic designing, UI UX designing and
//               web development.<br></br>I aim to create solutions which are user
//               friendly, minimal, intuitive and functional.
//               <br></br>
//               If I’m not designing or pondering over bugs, I spend my time
//               sketching,binge-reading,binge-watching or jamming to kpop songs.
//             </p>
//           </div>
//         </Grid>
//         <br></br>
//         <div style={{ display: "flex", justifyContent: "center" }}>
//           <DownloadButton />
//         </div>
//         <br></br>

//         <div id="Skills">
//           <Skills />
//         </div>
//         <br></br>
//         <div id="Projects">
//           <MyProjects openModal={openModal} setOpenModal={setOpenModal} />
//         </div>
//       </div>
//       <Footer />
//       {openModal.state && (
//         <ProjectDetails openModal={openModal} setOpenModal={setOpenModal} />
//       )}
//     </div>
//   );
// }

//WORKING COMPONENTS : Header, skills, projects, footer

function App() {
  const [openModal, setOpenModal] = useState({ state: false, project: null });
  const GradientLine = styled.div`
    height: 2px;
    background: linear-gradient(to right, var(--primary-color), #f2d2fa);
    flex: 1;
    margin: 0 1rem;
  `;
  const Section = styled.section`
    background-color: var(--background-color);
    color: white;
    padding: 4rem 1rem;
  `;

  const SubText = styled.p`
    color: var(--text-color);
    font-size: 1.5rem;
    font-weight: 300;
    max-width: 90%;
    line-height: 1.5;
    text-align: justify;

    @media (max-width: 768px) {
      text-align: justify;
      margin: 0 auto;
    }
  `;

  const Button = styled.button`
    border: 2px solid #c69ffb;
    color: #c69ffb;
    background: transparent;
    border-radius: 25px;
    padding: 10px 25px;
    margin-right: 15px;
    font-weight: 500;
    margin-top: 1.5rem;
    transition: 0.3s;

    &:hover {
      background-color: #c69ffb;
      color: #1e1e1e;
    }

    @media (max-width: 768px) {
      margin-right: 10px;
      margin-top: 1rem;
    }
  `;
  return (
    <>
      {/* Header- MAKE IT RESPONSIVE */}
      <Header />
      {/* Landing page DONE*/}
      {/* TODO : Add links */}
      <LandingPage />
      {/* */}
      {/* About me */}
      <div id="Me" style={{ padding: "4rem" }}>
        <Container
          fluid
          className="d-flex align-items-center justify-content-between"
        >
          <h1 className="title">About Me</h1>
          <GradientLine />
        </Container>
        <Section>
          <SubText>
            I'm a Computer Science grad and currently a Technology Graduate
            Associate at LSEG, working with a team that handles certifications
            and attestations,making sure products stay sharp, secure, and
            compliant so I've picked up a good deal about information security,
            compliance, and all those fascinating regulations behind the scenes.
            <br></br>
            <br></br>
            When I’m not working on tech solutions or navigating policies, I’m
            probably building something with the MERN stack I love crafting
            clean, user-friendly interfaces and believe good design starts with
            empathy and a little curiosity.
            <br></br>
            <br></br>
            Outside of code, you’ll usually find me sketching something random
            or getting lost in a good book. Stories fuel my creativity — whether
            they're told through pixels or pages.
          </SubText>
          <Button>Read my blog</Button>
          <Button>Check out my art page</Button>
        </Section>
      </div>
      {/* Skills */}
      <div id="Skills" style={{ padding: "4rem" }}>
        <Container
          fluid
          className="d-flex align-items-center justify-content-between"
        >
          <GradientLine />
          <h1 className="title"> My Skills</h1>
        </Container>
        <Skills />
      </div>
      <br></br>
      {/* Projects */}
      <div id="Projects" style={{ padding: "4rem" }}>
        <Container
          fluid
          className="d-flex align-items-center justify-content-between"
        >
          <h1 className="title">My Projects</h1>
          <GradientLine />
        </Container>
        <MyProjects openModal={openModal} setOpenModal={setOpenModal} />
      </div>
      {/* Footer DONE*/}
      <Footer />
      {openModal.state && (
        <ProjectDetails openModal={openModal} setOpenModal={setOpenModal} />
      )}
    </>
  );
}
export default App;
